class PayFromBalanceReq{

    constructor() {
  
      this.userId = undefined;
      this.accountingSessionId = undefined;
      this.packageId = undefined;
      this.paymentType = undefined;
  
      
    }
  }
  export default PayFromBalanceReq;